'use es6';

import debounce from 'react-utils/debounce';
import { converterNames } from 'rich-text-lib/lib/pastePreProcess';
import { COMMANDS_TO_TRACK, EVENTS_TO_TRACK } from '../../../constants/usageTracking';
import { CORE_SETTINGS } from '../../../constants/hscore';
import { trackInteraction } from '../../../utils/usageTracking';
import { getPasteInfo } from '../../../utils/paste';
import { hspasteConfig } from '../../../constants/hspaste';
import { getPastePluginSetting } from '../../../hspaste/utils';
import { isEditableImage } from '../../../utils/image';
import { getPluginSetting } from '../../../utils';
const googleImportSource = converterNames.CONVERT_GOOGLE_IMPORT_TO_HTML;
const DEBOUNCE_TIMEOUT = 1000;
export default function initUsagePlugin(editor) {
  const allowEmbedUrlPasting = getPastePluginSetting(editor, hspasteConfig.EMBED_URL_PASTING);
  const pluginSettings = getPluginSetting(editor, CORE_SETTINGS, {});
  let pasteInfo = {
    type: undefined,
    pasteSource: undefined,
    hasImages: undefined,
    pasteContent: undefined
  };
  editor.on('BeforeExecCommand', event => {
    const cmd = event.command.toLowerCase();
    if (COMMANDS_TO_TRACK[cmd]) {
      const action = COMMANDS_TO_TRACK[cmd];
      let meta = {};
      if (action === COMMANDS_TO_TRACK.mcetoggleformat) {
        meta = {
          value: event.value || cmd
        };
      }
      if (cmd.indexOf('justify') === 0) {
        const target = editor.selection.getNode();
        if (isEditableImage(editor, target)) return;
      }
      trackInteraction(editor, 'tinymceCommand', action, meta);
    }
  });
  Object.keys(EVENTS_TO_TRACK).forEach(eventToTrack => {
    editor.on(eventToTrack, event => {
      const action = EVENTS_TO_TRACK[eventToTrack];
      const meta = {
        version: 'v1'
      };
      if (eventToTrack === 'paste') {
        const {
          type,
          pasteSource,
          hasImages
        } = getPasteInfo(event, {
          allowEmbedUrlPasting
        });
        if (pasteSource === googleImportSource) return;
        pasteInfo = {
          type,
          pasteSource,
          hasImages
        };
      } else if (eventToTrack === 'pastePreProcess') {
        const {
          type,
          pasteSource,
          hasImages
        } = pasteInfo;

        // Dnd triggers pastePreProcess but we don't want to track that
        if (!type) return;
        const prePasteContent = editor.getContent({
          format: 'text'
        });
        const selectedContent = editor.selection.getContent({
          format: 'text'
        });
        if (pasteSource === googleImportSource) return;
        const overwriteExisting = prePasteContent === selectedContent;
        trackInteraction(editor, 'tinymcePaste', action, Object.assign({}, meta, {
          type,
          pasteSource,
          hasImages,
          overwriteExisting
        }));

        // Reset pasteInfo
        pasteInfo = {};
      } else {
        trackInteraction(editor, 'tinymceEvent', action, meta);
      }
    });
  });
  if (pluginSettings.shouldTrackInsertText) {
    const trackInsertText = debounce(event => {
      if (!event.inputType || event.inputType !== 'insertText') {
        return;
      }
      trackInteraction(editor, 'tinymceEvent', 'insert-text');
      editor.off('input', trackInsertText);
    }, DEBOUNCE_TIMEOUT);

    // We're only intersted in tracking the first time that text is inserted
    // into a blank document.
    editor.on('LoadContent', () => {
      const hasInitialContent = Boolean(editor.getContent().length);
      if (!hasInitialContent) {
        editor.on('input', trackInsertText);
      }
    });
  }

  // Set [trackInteraction] with the resolved handler
  editor.settings.trackInteraction = trackInteraction;
}